import Config from '../config/general-config';
import baseService from './base.service';

const menuBoardService = () =>
  baseService.getRequest(Config.ENDPOINTS.MENU_BOARD);

export default menuBoardService;
